 
import Vue from 'vue';
import { Component, Prop, ProvideReactive } from 'vue-property-decorator';
import CPDueDiligenceGeneralDetails from './CPDueDiligenceGeneralDetails.vue';
import CPDueDiligenceSource from './CPDueDiligenceSource.vue';
import { DueDiligenceFormStage } from '@/store/dueDiligence/types';
import { DueDiligenceFormStages, SourceTypes } from '@/store/dueDiligence/constants';
import CPDueDiligenceStageContainer from './CPDueDiligenceStageContainer.vue';
import CPDueDiligenceMoreInformation from './CPDueDiligenceMoreInformation.vue';

@Component({
    components: {
        CPDueDiligenceGeneralDetails,
        CPDueDiligenceSource,
        CPDueDiligenceStageContainer,
        CPDueDiligenceMoreInformation
    }
})
export default class CPDueDiligenceForm extends Vue {
    @Prop({ type: Number, required: false })
    readonly userInfoId!: number | null;

    readonly formStages = DueDiligenceFormStages;
    readonly sourceTypes = SourceTypes;

    @ProvideReactive()
    get viewOnly(): boolean {
        return this.$store.state.dueDiligence.isViewOnly;
    }

    get stage(): DueDiligenceFormStage {
        return this.$store.state.dueDiligence.formStage;
    }

    async created() {
        if (!this.$store.state.dueDiligence.details || this.userInfoId)
            await this.$store.dispatch('dueDiligence/getUserDetails', this.userInfoId ?? this.$store.state.account.details.userId);
    }
}
